function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classNames from 'classnames';
import React from 'react';
import Div from '../div';
import Link from '../link';
import Text from '../text';
import styles from './styles.module.scss';
import { getLinkDetailArrays } from './utils';

var LinkBank = function LinkBank(_ref) {
  var classes = _ref.classes,
      _ref$isAlternatingBgC = _ref.isAlternatingBgColorEnabled,
      isAlternatingBgColorEnabled = _ref$isAlternatingBgC === void 0 ? true : _ref$isAlternatingBgC,
      title = _ref.title,
      links = _ref.links,
      _ref$numberOfColumns = _ref.numberOfColumns,
      numberOfColumns = _ref$numberOfColumns === void 0 ? 2 : _ref$numberOfColumns,
      titleTextAs = _ref.titleTextAs,
      linkComponent = _ref.linkComponent;
  var linkArrays = links ? getLinkDetailArrays(links, numberOfColumns) : [];
  var flexBasis = 12 / numberOfColumns;
  var evenStyle = classNames(styles.even, classes === null || classes === void 0 ? void 0 : classes.even);
  var oddStyle = classNames(styles.odd, classes === null || classes === void 0 ? void 0 : classes.odd);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "app-link-bank",
    className: classes === null || classes === void 0 ? void 0 : classes.root
  }, title && /*#__PURE__*/React.createElement(Div, {
    marginLeft: 3,
    marginBottom: 4
  }, /*#__PURE__*/React.createElement(Text, _extends({
    weight: "bold",
    size: "xl",
    altFont: true
  }, titleTextAs ? {
    as: titleTextAs
  } : {}), title)), /*#__PURE__*/React.createElement(Div, {
    desktopDisplay: "flex",
    className: classNames(styles.linkBank, classes === null || classes === void 0 ? void 0 : classes.linkBank)
  }, links && linkArrays.map(function (array, index) {
    return /*#__PURE__*/React.createElement(Div, {
      key: index,
      desktopFlexBasis: flexBasis,
      desktopMarginRight: 5,
      "data-testid": "app-link-bank__".concat(title ? "".concat(title === null || title === void 0 ? void 0 : title.toLocaleLowerCase().replace(/[^A-Z0-9]/gi, '-'), "_") : '').concat(index),
      role: "list"
    }, array.map(function (_ref2, index) {
      var id = _ref2.id,
          url = _ref2.url,
          name = _ref2.name;
      return /*#__PURE__*/React.createElement(Div, {
        key: id ? id : name,
        className: isAlternatingBgColorEnabled ? index % 2 === 0 ? evenStyle : oddStyle : undefined,
        role: "listitem"
      }, /*#__PURE__*/React.createElement(Link, {
        className: classNames(styles.link, classes === null || classes === void 0 ? void 0 : classes.link),
        LinkComponent: linkComponent,
        align: "left",
        block: true,
        importance: "link",
        href: url || '/404',
        role: "link"
      }, name));
    }));
  })));
};

export default LinkBank;